import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { UserDetailSaveModel } from '../../user-details/models/user-detail-save.model';

export const addUser = createAction('[Add User] Add User');

export const createUser = createAction('[Create User] Create User', props<{ user: UserDetailSaveModel }>());

export const createUserSuccess = createAction(
   '[API] Create User Success',
   props<{ userId: number; userName: string | null }>()
);

export const createUserFailure = createAction('[API] Create User Failure', props<SingleGraphError>());
